var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plk_layer_generator p-3"},_vm._l((_vm.status),function(item,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(_vm.$t(item))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }